module.exports = __webpack_public_path__ + "img/fwlc.22ceb12c.png";